import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Link } from 'src/core-lib/navigation/models/link.model';

@Component({
    selector: 'app-recursive-link',
    standalone: true,
    imports: [RouterModule, TranslateModule],
    templateUrl: './recursive-link.component.html',
    styleUrl: './recursive-link.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecursiveLinkComponent {
    @Input() link: Link | null = null;
    @Input() selected: Link | null = null;
    @Input() prev: Link | null = null;
    @Output() select = new EventEmitter<Link>();
    isMobile = matchMedia('screen and (width <= 1240px)').matches ;

}
